import config from "config";
import { PATH_NAME_BASE } from "helpers/validators.js";

const getRequest = async (
  controller,
  functionName,
  parameters,
  contentType,
  authKey,
  culture,
  signal
) => {
  let url = `${config.api.src}/${controller}/${functionName}`;

  if (parameters) {
    url += "?";
    Object.keys(parameters).forEach((key) => {
      url += `${key}=${encodeURIComponent(parameters[key])}&`;
    });
  }

  const headers = new Headers();
  headers.append("Authorization", authKey ? "Bearer " + authKey : false);
  headers.append("Content-Type", contentType);
  headers.append("Accept", "*/*");
  headers.append("X-Culture", culture);
  headers.append("X-Origin", window.location.origin);

  // Create custom referrer with hostname + language + current page
  const hostname = window.location.hostname; // e.g., jumbomail.me
  const pathname = window.location.pathname; // e.g., /en/home/section/subsection

  // Extract only first two path segments (language and pagename)
  const pathSegments = pathname.split("/").filter((segment) => segment); // Remove empty segments
  const language = pathSegments[0] || ""; // First segment (language)
  const pagename = pathSegments[1] || ""; // Second segment (pagename)

  // Construct referrer with only hostname, language and pagename
  const customReferrer = `${hostname}/${language}/${pagename}`;
  headers.append("X-Referer", customReferrer);

  const response = await fetch(url, {
    method: "GET",
    headers: headers,
    signal: typeof signal === "string" ? undefined : signal,
    credentials: "include",
  });

  // should add more cases as needed
  switch (response.status) {
    case 200:
      try {
        const res = await response.json();
        return { status: "success", data: res };
      } catch (e) {
        return { status: "success", data: response };
      }
    case 204:
      return { status: "success" };
    case 409:
      const text = await response.text();
      if (text === "CaptchaRequired")
        return { status: "recaptcha", data: "recaptcha-required" };
      else return { status: "error", data: text };
    case 403:
      return { status: "error", data: "access-forbidden" };

    case 429:
      // doing redirect to /user-blocked page, if its not already there
      if (!window.location.pathname.includes("/user-blocked")) {
        const pathBase = window.location.pathname.match(PATH_NAME_BASE);
        if (pathBase) {
          window.location.pathname = pathBase[0] + "user-blocked";
        }
      }

    default:
      return { status: "error", data: await response.text() };
  }
};

export default getRequest;
